import type { KftApiDefaultResponse } from '~/composables/types/kft-api'
import type { Supplier } from '~/composables/types/event'
import { useSubdomain } from '~/composables/useSubdomain'

export const useSubdomainData = () => {
  const subdom = useSubdomain()
  const fullLocalizedUrl = useFullLocalizedUrl()

  return useKftApiFetch<KftApiDefaultResponse<Supplier>, Supplier>(
    `v1/store/suppliers/${subdom.value}/subdomain?include=logo,booking_solution_settings`,
    {
      key: 'subdomainData:' + subdom.value,
      server: true,
      immediate: Boolean(subdom.value),
      transform: (data) => data?.data,
      onResponseError: (_error) => {
        navigateTo(
          { path: fullLocalizedUrl('/') },
          { external: true, redirectCode: 301 }
        )
      },
      onResponse({ response }) {
        if (!response._data.data.id) {
          navigateTo(
            { path: fullLocalizedUrl('/') },
            { external: true, redirectCode: 301 }
          )
        }
      },
    }
  )
}
